/* eslint-disable react-hooks/exhaustive-deps */
import ArrowBack from '@mui/icons-material/ArrowBackIos';
import { Formik } from 'formik';
import { isEmpty, isObject, isString } from 'lodash';
import React, { useEffect, useState } from 'react';
import { PhoneInput } from 'react-international-phone';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { toast } from 'react-toastify';
import { LOCAL_STORAGE_KEYS } from '../../../../global/const';
import FormikPlaceSearch from '../../../components/UI/FormikPlaceSearch';
import TextInput from '../../../components/UI/TextInput';
import PageLoader from '../../../components/loaders/PageLoader';
import { hideLoading, showLoading } from '../../../redux/loader/LoaderActions';
import { GET, PUT } from '../../../services/rest.service';
import FamilyUpdateSchema from '../../../validationSchema/families/FamilyUpdateSchema';

const FamilyForm = (props) => (
  <Formik
    initialValues={{
      first_name: props.values.first_name,
      last_name: props.values.last_name,
      email: props.values.email,
      mobile_number: props.values.mobile_number,
      location: isObject(props.values.location) ? props.values.location.address : props.values.location,
    }}
    onSubmit={(values) => {
      props.onSubmit(values);
    }}
    validationSchema={FamilyUpdateSchema}
  >
    {(renderProps) => {
      const { values, touched, errors, handleChange, handleBlur, setFieldValue, handleSubmit } = renderProps;

      return (
        <form className="row" onSubmit={handleSubmit}>
          <TextInput
            label={'First Name'}
            labelClasses={'text-uppercase'}
            placeholder={'Please enter first name'}
            size={'col col-lg-6'}
            value={values.first_name}
            error={touched.first_name && errors.first_name}
            onChange={handleChange}
            onBlur={handleBlur}
            name={'first_name'}
            id={'first_name'}
          />
          <TextInput
            label={'Last Name'}
            labelClasses={'text-uppercase'}
            size={'col col-lg-6'}
            placeholder={'Please enter last name'}
            error={touched.last_name && errors.last_name}
            value={values.last_name}
            onChange={handleChange}
            onBlur={handleBlur}
            name={'last_name'}
            id={'last_name'}
          />
          <TextInput
            label={'Email'}
            labelClasses={'text-uppercase'}
            size={'col col-lg-6'}
            placeholder={'Please enter email'}
            type={'email'}
            error={touched.email && errors.email}
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            name={'email'}
            id={'email'}
          />

          <div className={'form-group col col-lg-6'}>
            <label className={'form-label text-uppercase'}>Mobile Number</label>
            <PhoneInput defaultCountry="us" value={values.mobile_number} onChange={(e, phone) => setFieldValue('mobile_number', phone.inputValue)} onBlur={handleBlur} />
          </div>

          <FormikPlaceSearch
            id={'location'}
            name={'location'}
            label={'Location'}
            labelClasses={'text-uppercase'}
            size={'col col-lg-6'}
            value={values.location}
            onChange={(e) => {
              const place = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.LOCATION));
              setFieldValue('location', place);
              setTimeout(() => {
                localStorage.removeItem(LOCAL_STORAGE_KEYS.LOCATION);
              }, 100);
            }}
            placeholder={'Please enter location'}
          />

          <div className="form-group col-12 mt-3">
            <button type="button" className="btn btn-danger btn-lg" onClick={() => props.navigate(-1)}>
              Discard Changes
            </button>
            &nbsp;&nbsp;&nbsp;
            <button type="submit" className="btn btn-primary btn-lg" onClick={handleSubmit}>
              Update
            </button>
          </div>
        </form>
      );
    }}
  </Formik>
);

const FamilyUpdate = () => {
  const [family, setFamily] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const skills = useSelector((state) => state.skills);
  const { id } = useParams();

  const doUpdateFamilyAccount = async (formData) => {
    const { location } = family;

    const payload = {
      ...formData,
      _id: id,
      type: 'Family',
      location: isString(formData.location) ? location : formData.location,
    };
    dispatch(showLoading('Updating account...'));
    try {
      await PUT(`/admin/family/${id}/edit`, payload);
      navigate(-1);
      toast.success('Family account details updated!');
      dispatch(hideLoading());
    } catch (err) {
      toast.error(err.message);
      dispatch(hideLoading());
    }
  };

  const getUser = async () => {
    try {
      const family = await GET(`/admin/user/get_by_id/${id}`);
      setFamily(family.data);
    } catch (err) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  if (isEmpty(family)) {
    return <PageLoader />;
  }

  return (
    <div className="container-fluid px-xl-5">
      <section className="py-5">
        <div className="row">
          <div className="col-lg-8 mb-5">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h3 className="h6 text-uppercase mb-0">
                  <a href="#!" onClick={() => navigate(-1)}>
                    <ArrowBack />
                  </a>
                  Update Family Account
                </h3>
                <small className="text-danger">*All fields are required</small>
              </div>
              <div className="card-body">
                <FamilyForm onSubmit={doUpdateFamilyAccount} values={family} skills={skills} navigate={navigate} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FamilyUpdate;
